import { ComponentProps, ElementType } from 'react';
import * as Flowbite from 'flowbite-react';
import { getReplaceThemeProps } from 'utils/replaceTheme';
import { theme } from './theme';
import { useButtonSpinner } from './useButtonSpinner';

type FlowbiteButtonProps<T extends ElementType = 'button'> = Pick<
    Flowbite.ButtonProps<T>,
    'as' | 'color' | 'size' | 'pill' | 'outline'
>;

type ButtonProps<T extends ElementType = 'button'> = {
    loading?: boolean;
} & FlowbiteButtonProps<T> &
    ComponentProps<T>;

export const Button = <T extends ElementType = 'button'>({
    as,
    children,
    color = 'primary',
    loading = false,
    ...props
}: ButtonProps<T>) => {
    const buttonSpinner = useButtonSpinner(loading);

    return (
        <Flowbite.Button
            as={as} // TypeScript throws when spreading `as` prop in `...props`.
            color={color}
            {...getReplaceThemeProps(theme)}
            {...props}
        >
            {buttonSpinner}
            {children}
        </Flowbite.Button>
    );
};
